{
    "overview__today_sales": "Order Sum Today",
    "overview__today_margin": "Margin today",
    "overview__today_order_count": "Orders today",
    "overview__yesterday": "Yesterday",
    "section_title__revenue_invoiced": "Total Sales (invoiced)",
    "section_title__margin_invoiced": "Gross Margin (invoiced)",
    "section_title__margin_order_sum": "Gross Margin (Order Sum)",
    "section_title__order_sum_total": "Total Order Sum",
    "chart_label__last_year": "same month last year",
    "analysis_section__ai_notice": "Recommended Customers",
    "analysis_section__expansion_potential_title": "🚀 Largest Expansion Potential",
    "analysis_section__expansion_potential_subtitle": "These customers have the highest absolute expansion potential",
    "analysis_section__revenue_decline_title": "⚠️ Largest Churn",
    "analysis_section__revenue_decline_subtitle": "These customers have the highest absolute churn warnings",
    "analysis_section__show_all": "Show all",
    "tab_title_order_overview__open_quotes": "Open Quotes",
    "tab_title_order_overview__open_orders": "Open Orders",
    "table_header__sales": "Sales",
    "overview__filter_billed": "Billed",
    "activities__tasks_title_one": "Open Task",
    "activities__tasks_title_other": "Open Tasks",
    "activities__events_title_one": "Event",
    "activities__events_title_other": "Events",
    "activities__create_task": "New Task",
    "activities__create_event": "New Event",
    "activities__event_title": "Customer visit",
    "dashboard__empty_state__title": "Nothing upcoming",
    "dashboard__empty_state__subtitle": "<0>Task</0> or <1>Event</1> to add",
    "dashboard__empty_state__subtitle_tasks_only": "<0>Task</0> to add",
    "analysis_section__snippets__revenue-delta": "{{revenueDelta, number}} Revenue",
    "analysis_section__snippets__order-sum-delta": "{{revenueDelta, number}} Order Sum",
    "analysis_section__snippets__days-since-first-order": "{{days}}d since first order",
    "analysis_section__snippets__days-since-last-order": "{{days}}d since last order",
    "analysis_section__snippets__open_quotes_one": "{{count}} open quote",
    "analysis_section__snippets__open_quotes_other": "{{count}} open quotes",
    "analysis_section__snippets__cross_sell_one": "{{count}}x Cross-Sell",
    "analysis_section__snippets__cross_sell_other": "{{count}}x Cross-Sell",
    "analysis_section__snippets__cross_sell_never_bought_one": "{{count}}x Never bought",
    "analysis_section__snippets__cross_sell_never_bought_other": "{{count}}x Never bought",
    "analysis_section__snippets__share_of_wallet_one": "{{count}}x Share of Wallet",
    "analysis_section__snippets__share_of_wallet_other": "{{count}}x Share of Wallet",
    "analysis_section__snippets__first_purchase_one": "{{count}}x First Purchase",
    "analysis_section__snippets__first_purchase_other": "{{count}}x First Purchase",
    "analysis_section__snippets__churn_warning_one": "{{count}}x Churn",
    "analysis_section__snippets__churn_warning_other": "{{count}}x Churn",
    "snippet_sales_insights_one": "{{count}} Sales Insight",
    "snippet_sales_insights_other": "{{count}} Sales Insights",
    "analysis_section__show_dormant_customers": "Show dormant customers",
    "chart_tabs__metric_label": "Metric"
}
